import React from "react";

function AppsDetails({deployment}) {
    return (
        <div>
                Content
        </div>
    )
}

export default AppsDetails